import type { PropsWithChildren } from 'react';

type BreadcrumbProps = PropsWithChildren<{
  className?: string;
}>;

export const Breadcrumb = ( { className, children }: BreadcrumbProps ) => {

  return (
    <nav
      aria-label={ 'breadcrumb' }
      className={ className }>
      { children }
    </nav>
  );
}
Breadcrumb.displayName = 'Breadcrumb';
